import React from "react";

import { css } from "@emotion/css";

import { usePatientFromURL } from "@/hooks/usePatientIdFromURL.ts";
import { useStyles } from "@/hooks/useStyles.ts";
import { DiabetesAndDevices } from "@/pages/patient-medical-file/DiabetesAndDevices.tsx";
import { Entourage } from "@/pages/patient-medical-file/Entourage.tsx";
import { PatientProfile } from "@/pages/patient-medical-file/PatientProfile.tsx";
import { TelemonitoringCard } from "@/pages/patient-settings/TelemonitoringCard.tsx";
import { Theme } from "@/theme/CreateTheme.ts";
import { useScreenSize } from "@/theme/responsive.ts";
import { PatientNoteCard } from "@/uiKit/organisms/PatientNoteCard.tsx";

export const PatientMedicalFile: React.FC = () => {
  const styles = useStyles(makeStyles);
  const patient = usePatientFromURL();
  const screenSize = useScreenSize();
  switch (screenSize) {
    case "SM":
    case "MD":
    case "LG":
      return (
        <div className={styles.container}>
          <TelemonitoringCard patientId={patient.id} />
          <PatientProfile patientId={patient.id} />
          <PatientNoteCard patientId={patient.id} className={styles.noteSmall} />
          <DiabetesAndDevices patientId={patient.id} />
          <Entourage patientId={patient.id} />
        </div>
      );
    default:
      return (
        <div className={styles.container}>
          <div className={styles.columns}>
            <div className={styles.column}>
              <TelemonitoringCard patientId={patient.id} />
              <PatientProfile patientId={patient.id} />
            </div>
            <div className={styles.column}>
              <PatientNoteCard patientId={patient.id} className={styles.noteLarge} />
              <DiabetesAndDevices patientId={patient.id} />
              <Entourage patientId={patient.id} />
            </div>
          </div>
        </div>
      );
  }
};

const makeStyles = (theme: Theme) => ({
  container: css`
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: ${theme.spacing(12)};
  `,
  columns: css`
    display: flex;
    flex-direction: row;
    gap: ${theme.spacing(8)};
  `,
  column: css`
    display: flex;
    flex-direction: column;
    flex: 1 1 0;
    min-width: 0;
    gap: ${theme.spacing(8)};
  `,
  noteLarge: css`
    display: flex;
    flex-direction: column;
  `,
  noteSmall: css`
    flex: 1 1 auto;
    flex-direction: column;
    display: flex;
    max-height: 90vh;
  `,
});
